import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

export function initGlightbox() {
    const gallery = document.querySelector('.portfolio-single__fullwidth');
    const content = document.querySelector('.portfolio-single__content');
    const details = document.querySelector('.portfolio-single__details');

    if (!gallery && !content && !details) return;

    // Full-width gallery
    if (gallery) {
        GLightbox({ selector: '.portfolio-single__fw-link' });
    }

    // Image links inside wysiwyg content & details
    const contentLinks = [
        ...(content ? content.querySelectorAll('a[href]') : []),
        ...(details ? details.querySelectorAll('a[href]') : []),
    ].filter(a => /\.(jpe?g|png|gif|webp|avif|svg)(\?.*)?$/i.test(a.href));

    if (contentLinks.length) {
        contentLinks.forEach(a => a.classList.add('glightbox-content'));
        GLightbox({ selector: '.glightbox-content' });
    }
}
